import { useState, useEffect } from "react";
import services from '../../services/index'


const StateCity = ({type, classname, cval, userDetails, setUserDetails, setCity, city}) => {

    const [state, setState] = useState([]);

    useEffect(() => {
        //console.log(userDetails,'ddddd');
        if(type=='state'){
            ( async () => { 
                const stateData =  await services.usersService.getState()
                if(stateData?.error===0){
                setState(stateData?.data?.result)
                if(userDetails?.pState>0) getCities(userDetails?.pState)
                }
            } 
            )()
        }

    }, []);

    const getCities = async (stateId) => { 
        const cityData =  await services.usersService.getCity({state_id:stateId})
        if(cityData?.error===0){
          setCity(cityData?.data?.result)
        }
      }
    
      const onChangeState = (stateId) => {
        setUserDetails({ ...userDetails, pState:stateId});
        if(stateId>0) getCities(stateId)
    
      }

    return (
        <>
        { type=='state' && 
        <select 
            placeholder="State"
            className={classname}
            value={cval}
            onChange={(e) =>
            onChangeState(e.target.value) 
            }
            >
            <option value='0' >--- Select ---</option>
            {state.map((option) => (
            <option value={option.state_id}>{option.name}</option>
            ))}
        </select>
        }

        { type=='city' && 
        <select 
            required
            placeholder="City"
            className={classname}
            value={cval}
            onChange={(e) =>
            setUserDetails({ ...userDetails, pCity: e.target.value })
            }
            >
            <option defaultValue='0' >--- Select ---</option>
            {city.map((option) => (
            <option defaultValue={cval===option.city_id ? cval : false} value={option.city_id}>{option.name}</option>
            ))}
        </select>
        }
        </>
    )
}

export default StateCity